// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__QCzOb","content":"LoadingAlert_content__3uZas"};